import { SectionHeading } from '@quickmd-llc/design-system'
import { AvailableAccounts } from './AvailableAccounts'
import { SelectedAccounts } from './SelectedAccounts'
import { MergeAccountsProvider } from './context/MergeAccountsProvider'
import { MergeAccountsButton } from './MergeAccountsButton'
import { CancelButton } from './CancelButton'

export function MergeAccountsPage() {
  return (
    <MergeAccountsProvider>
      <div style={{ width: '100%' }}>
        <div className='grid h-lvh [grid-template-rows:min-content_auto_min-content]'>
          <div className='px-sp-3 pb-sp-2 pt-[42px]'>
            <SectionHeading>Merge accounts</SectionHeading>
          </div>

          <div className='grid min-h-0 flex-1 bg-[#EFF3F6] p-sp-3 [grid-template-rows:auto_min-content]'>
            <div className='grid h-full min-h-0 grid-cols-2 gap-sp-3'>
              <AvailableAccounts />

              <SelectedAccounts />
            </div>
          </div>

          <div className='flex justify-end gap-sp-1 border-t border-border-dark bg-white p-sp-2'>
            <CancelButton />

            <MergeAccountsButton />
          </div>
        </div>
      </div>
    </MergeAccountsProvider>
  )
}
